import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import SecurityRightMenu from 'apps/auth/components/profile/security/SecurityRightMenu';
import BasePage from 'apps/auth/components/utils/BasePage';
import Languages from 'apps/auth/components/utils/Languages';
import { AUTH_PROFILE, AUTH_PROFILE_NOTIFICATION, AUTH_SECURITY, AUTH_APPEARANCE } from 'apps/auth/constants/UrlConstants';
import { getCurrentLang } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const ProfileSettingsPage = (props) => {
    const { hideCreationOfPassword } = useExtra();
    const popupRef = useRef(null);

    const { title, profileMenuAuthSettings, profileMenuAppearance, profileMenuLanguage, profileMenuSettings, profileMenuNotification } = usePageMessages();

    return (
        <>
            <CommonPage backUrl={AUTH_PROFILE} rightHeaderComponent={hideCreationOfPassword && <SecurityRightMenu popupRef={popupRef} />}>
                <HeaderPanel title={profileMenuSettings} />
                <Panel
                    type="button"
                    negativeMargin
                    hasIcon
                    isHoverable
                    onClick={() => props.toggleModal(true, <Languages title={title} lang={props.lang} languages={props.languages} isAuthZone={true} />)}
                >
                    <PanelRow>
                        <PanelRow alignStart>
                            <IconWrapper>
                                <Icon name="flag" color="primary" />
                            </IconWrapper>
                            <Text>{profileMenuLanguage}</Text>
                        </PanelRow>
                        <PanelRightBlock>{getCurrentLang(props.languages, props.lang)}</PanelRightBlock>
                    </PanelRow>
                </Panel>
                <Panel type="reactLink" hasIcon to={AUTH_PROFILE_NOTIFICATION} negativeMargin isHoverable>
                    <IconWrapper>
                        <Icon name="bell" color="primary" />
                    </IconWrapper>
                    <Text>{profileMenuNotification}</Text>
                </Panel>
                {!hideCreationOfPassword && (
                    <Panel type="reactLink" to={AUTH_SECURITY} negativeMargin hasIcon isHoverable>
                        <IconWrapper>
                            <Icon name="lock" color="primary" />
                        </IconWrapper>
                        <Text>{profileMenuAuthSettings}</Text>
                    </Panel>
                )}
                <Panel type="reactLink" to={AUTH_APPEARANCE} negativeMargin hasIcon isHoverable>
                    <IconWrapper>
                        <Icon name="eye" color="primary" />
                    </IconWrapper>
                    <Text>{profileMenuAppearance}</Text>
                </Panel>
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        languages: state.language.languages,
        lang: state.language.lang,
    };
};

export default connect(mapStateToProps, { toggleModal })(BasePage(ProfileSettingsPage));
